import { IState } from 'shared/store';

import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

export const CHATS_NEW_SEND_MESSAGE_FROM_OBJECT_CARD = 'aud_desktop_bx664_chats_from_object_card';

export const selectIsChatsNewSendMessageFromObjectCardGroupBExperimentEnabled = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, CHATS_NEW_SEND_MESSAGE_FROM_OBJECT_CARD, 'B');
};

export const selectIsChatsNewSendMessageFromObjectCardGroupCExperimentEnabled = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, CHATS_NEW_SEND_MESSAGE_FROM_OBJECT_CARD, 'C');
};
